'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }



var _module = _angular2.default.module('cb.core.site-header.cb-user-prefs', []);

_module.directive('cbUserPrefs', cbUserPrefsDirective);

exports.default = _module;


function cbUserPrefsDirective() {
    return {
        restrict: 'E',
        scope: {},
        controllerAs: 'userPrefs',
        controller: 'cbUserPrefsController',
        template: "<!-- Zoom -->\r\n<!--\r\n<div class=\"control-panel__item\">\r\n    <div class=\"control-panel__item-title\">Zoom</div>\r\n    <div class=\"control-panel__item-controls\">\r\n        <a href=\"\" class=\"control-panel__zoom\" ng-click=\"userPrefs.zoomOut()\">-</a>\r\n        <span class=\"control-panel__zoom-percentage\" ng-binding>100%</span>\r\n        <a href=\"\" class=\"control-panel__zoom\" ng-click=\"userPrefs.zoomIn()\">+</a>\r\n    </div>\r\n</div>\r\n-->\r\n\r\n<!-- Contrast -->\r\n<div class=\"control-panel__item\">\r\n    <div class=\"control-panel__item-title\">Contrast</div>\r\n    <div class=\"control-panel__item-controls\">\r\n        <a href=\"\" class=\"control-panel__contrast control-panel__contrast--normal\" ng-click=\"userPrefs.resetContrast()\"> </a>\r\n        <a href=\"\" class=\"control-panel__contrast control-panel__contrast--high\" ng-click=\"userPrefs.setContrast()\"> </a>\r\n    </div>\r\n</div>\r\n\r\n<!-- Dyslexie font -->\r\n<div class=\"control-panel__item\">\r\n    <div class=\"control-panel__item-title\">Dyslexie lettertype</div>\r\n    <div class=\"control-panel__item-controls\">\r\n        <a href=\"\" class=\"control-panel__link\" ng-click=\"userPrefs.setDyslexie()\">Aan</a>\r\n        <span>/</span>\r\n        <a href=\"\" class=\"control-panel__link\" ng-click=\"userPrefs.resetDyslexie()\">Uit</a>\r\n    </div>\r\n</div>\r\n\r\n<!-- Cookie -->\r\n<div class=\"control-panel__item\">\r\n    <div class=\"control-panel__item-title\">Cookies</div>\r\n    <div class=\"control-panel__item-controls\">\r\n        <a href=\"\" class=\"control-panel__link\" ng-click=\"userPrefs.showCookieSettings()\">Aanpassen</a>\r\n    </div>\r\n</div>\r\n"
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/site-header/cb-user-prefs.directive.js
// module id = 908
// module chunks = 0